import { render, staticRenderFns } from "./BusinessDataStage.vue?vue&type=template&id=0be41dec&scoped=true"
import script from "./BusinessDataStage.vue?vue&type=script&lang=js"
export * from "./BusinessDataStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be41dec",
  null
  
)

export default component.exports